import type { HlsConfig } from "hls.js";

export function createHlsConfig(): Partial<HlsConfig> {
  return {
    maxBufferLength: 90,
    backBufferLength: 120,
    liveSyncDurationCount: 3,
    liveMaxLatencyDurationCount: 9,
    lowLatencyMode: false,
    manifestLoadingTimeOut: 45_000,
    manifestLoadingMaxRetry: 10,
    manifestLoadingRetryDelay: 800,
    fragLoadingTimeOut: 30_000,
    fragLoadingMaxRetry: 10,
    fragLoadingRetryDelay: 800
  };
}
